import { FormControlLabel, FormControlLabelProps } from "@mui/material";
import { AriaRole } from "react";

const AccessibleFormControlLabel = (
    props: FormControlLabelProps,
) => {
    return <FormControlLabel tabIndex={0} {...props} onKeyUp={(e) => {
        if (e.key === 'Enter') {
            (e.target as HTMLInputElement).click();
        }
    }}/>;
}

export default AccessibleFormControlLabel; 